import { useParams } from '@tanstack/react-router'
import { usePreviewData } from '../features/preview-data'

/**
 * The `:idOrCode` route param for location-scoped screens (detail / network / wan-settings).
 * Design screens call this (screens stay `FC` with no props). Under /preview there is no param,
 * so it falls back to the mock location's code.
 */
export function useIdOrCode(): string {
  const params = useParams({ strict: false }) as { idOrCode?: string }
  const preview = usePreviewData()
  return params.idOrCode ?? preview?.locationDetail.aptosStoreCode ?? ''
}
